import type { DashboardOverview, FolderNode } from '../../domains/dashboard/models';

function folderIdInTree(roots: readonly FolderNode[], folderId: string): boolean {
  const stack = [...roots];
  while (stack.length > 0) {
    const folder = stack.pop()!;
    if (folder.id === folderId) return true;
    stack.push(...folder.children);
  }
  return false;
}

/** Returns the workspace route to retain when the active folder is removed. */
export function getFolderDeletionFallbackPath(
  overview: DashboardOverview | undefined,
  folderId: string,
): string {
  if (!overview) return '/recent';
  if (folderIdInTree(overview.personal.roots, folderId)) return '/personal';
  if (folderIdInTree(overview.org.roots, folderId)) return '/myorg';
  if (folderIdInTree(overview.sharedWithMe.roots, folderId)) return '/sharedwithme';
  for (const externalOrg of overview.externalOrgs ?? []) {
    if (folderIdInTree(externalOrg.roots, folderId)) return `/${externalOrg.orgId}`;
  }
  if (folderIdInTree(overview.archived.roots, folderId)) return '/archived';
  return '/recent';
}
